export enum ACTIONS {
  STRIP_FINISHED = "STRIP_FINISHED",
  STRIP_START = "STRIP_START",
  FORMAT_START = "FORMAT_START",
  FORMAT_FINISHED = "FORMAT_FINISHED",
}
